import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faGear, faCalendarAlt, faClock } from '@fortawesome/pro-light-svg-icons';
import { CartService } from 'src/app/services/cart.service';
import { PaymentMethod, isDirectPayment, setDirectPayment } from 'src/app/helpers/payment-preferences';

@Component({
  selector: 'app-dialog-settings',
  templateUrl: './dialog-settings.component.html',
  styleUrls: ['./dialog-settings.component.scss']
})
export class DialogSettingsComponent {
  faGear = faGear;
  faCalendar = faCalendarAlt;
  faClock = faClock;

  sortPreference: string = localStorage.getItem('cart_sort_preference') || 'session_date';
  cartDefaultCollapsed: boolean = localStorage.getItem('cart_default_collapsed') === 'true';
  directPayment: Record<PaymentMethod, boolean> = {
    cash: isDirectPayment('cash'),
    tpv: isDirectPayment('tpv'),
  };

  readonly paymentSections: { method: PaymentMethod; label: string; options: { direct: boolean; label: string; description: string }[] }[] = [
    {
      method: 'cash',
      label: 'Cobro en efectivo',
      options: [
        {
          direct: false,
          label: 'Pedir importe recibido',
          description: 'Se introduce lo que entrega el cliente y se calcula el cambio'
        },
        {
          direct: true,
          label: 'Cobro directo',
          description: 'Al pulsar efectivo se cobra el total, sin más pasos'
        }
      ]
    },
    {
      method: 'tpv',
      label: 'Cobro con tarjeta',
      options: [
        {
          direct: false,
          label: 'Pedir confirmación',
          description: 'Aviso para cobrar en el datáfono antes de confirmar el pago'
        },
        {
          direct: true,
          label: 'Cobro directo',
          description: 'Al pulsar tarjeta se registra el pago, sin más pasos'
        }
      ]
    }
  ];

  readonly sortOptions = [
    {
      value: 'session_date',
      label: 'Ordenar por fecha de evento',
      description: 'Los eventos más próximos aparecen primero'
    },
    {
      value: 'created_at',
      label: 'Ordenar por orden de añadido',
      description: 'Las entradas aparecen en el orden en que se añadieron'
    }
  ];

  constructor(
    private dialogRef: MatDialogRef<DialogSettingsComponent>,
    private cartService: CartService
  ) {}

  selectSort(value: string) {
    this.sortPreference = value;
    localStorage.setItem('cart_sort_preference', value);
    this.cartService.getCart().subscribe();
  }

  selectCartDefault(collapsed: boolean) {
    this.cartDefaultCollapsed = collapsed;
    this.cartService.setCartCollapsed(collapsed);
  }

  selectDirectPayment(method: PaymentMethod, direct: boolean) {
    this.directPayment[method] = direct;
    setDirectPayment(method, direct);
  }

  close() {
    this.dialogRef.close();
  }
}
